export enum Template {
  Standard = 1,
  TD = 2,
  StandardResidential = 3,
}